module.exports = __webpack_public_path__ + "static/media/digial-media.6348cfa7.jpg";